// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.admanagement.selfserveonboarding.RentalManagerUserSelfServiceOnboardingV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing } from '@zg-rentals/ts-rental-manager-api-client';

import type { SubmitManualListingV2RequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing_Args {
  postData: SubmitManualListingV2RequestDto;
}

export type RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing_Args
>;

/**
 * Submit manual self serve onboarding listing for review
 */
export const useRentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing_Args) =>
      RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing(args.postData, httpClient),
  });
};
